// components/LoadingPage.jsx
import React from 'react';
import styles from './InitialLoading.module.css';
import Footer from '../../../Layout/Footer';
import { CircularProgress } from '@mui/material';

const bannerTitle = 'TREA Ordering Management System';

const InitialLoading = ({ message = 'Loading...' }) => {
    return (
        <div className={styles.main}>
            <header className={styles.header}>
                {bannerTitle}
            </header>
            <section className={styles.section}>
                <CircularProgress 
                    size={60} 
                    sx={{ color: 'var(--trea-brand-color-aqua)' }}
                />
                <p className={styles.message}>{message}</p>
            </section>
            <Footer />
        </div>
    );
};

export default InitialLoading;